import { render } from "./InsuranceCalculationHome.vue?vue&type=template&id=850f6122&scoped=true&lang=pug"
import script from "./InsuranceCalculationHome.vue?vue&type=script&lang=js"
export * from "./InsuranceCalculationHome.vue?vue&type=script&lang=js"

import "./InsuranceCalculationHome.vue?vue&type=style&index=0&id=850f6122&lang=scss&scoped=true"
import "./InsuranceCalculationHome.vue?vue&type=style&index=1&id=850f6122&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850f6122"]])

export default __exports__